const format = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2})

export const formatMoney = (sumCents) => {
    return format.format(sumCents / 100.0)
}
